module.exports = __webpack_public_path__ + "static/img/zq2.b7ce700.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/zq2.jpeg
// module id = pfm0
// module chunks = 0